module.exports = __webpack_public_path__ + "img/idea-committee@3x.8cedf225.webp";